export function addStyleTagToHeader(htmlString, stylesPath) {
  const content = new DOMParser().parseFromString(htmlString, 'text/html');
  const stylesTag = content.createElement('link');
  stylesTag.setAttribute('rel', 'stylesheet');
  stylesTag.setAttribute('href', stylesPath);
  content.head.append(stylesTag);
  return content.documentElement.outerHTML;
}

export const enableTab = (activeElement, elementsToShow) => {
  document.querySelectorAll('.tab-pane.fade').forEach((el) => {
    el.classList.remove('active');
  });
  document.getElementById(activeElement).className = document.getElementById(activeElement).className + ' in active';

  elementsToShow.forEach((element) => {
    document.querySelectorAll('.' + element).forEach((el) => {
      el.classList.remove('hide');
    });
  });
};
